import type { ReactNode } from 'react';
import { AccessDeniedPage } from '@/components/pages/WorkspaceStatusPage';
import { usePageAccess } from '@/hooks/usePageAccess';

interface PageViewGateProps {
  children: ReactNode;
  /** Route path to evaluate; defaults to current location. */
  path?: string;
  fallback?: ReactNode;
}

/** Blocks page content when the user lacks view permission — shows Access Denied, not a blank screen. */
export function PageViewGate({ children, path, fallback }: PageViewGateProps) {
  const { canView } = usePageAccess(path);

  if (!canView) {
    return <>{fallback ?? <AccessDeniedPage />}</>;
  }

  return <>{children}</>;
}
